import InstallerSimulator from './InstallerSimulator.jsx';
import CorrectnessTally from './CorrectnessTally.jsx';

/**
 * Teacher/projector view for a checkbox_sim question — mirrors the exact
 * installer window students see on their own device (read-only, submit
 * button hidden), so the class has a shared reference while everyone works
 * individually. On reveal, swaps to an "answer key" render of the same
 * window with the required box(es) pre-checked and badged.
 */
export default function HostCheckboxPreview({ payload, revealed, tally }) {
  return (
    <div className="stack host-checkbox-preview">
      <InstallerSimulator
        windowTitle={payload.windowTitle}
        heading={payload.heading}
        checkboxes={payload.checkboxes}
        submitLabel={payload.submitLabel}
        disabled
        hideSubmit
        revealCorrectIndices={revealed ? payload.requiredIndices || [] : null}
      />

      {!revealed && (
        <p className="host-preview-caption text-dim text-center">
          ผู้เรียนกำลังทำตามขั้นตอนนี้บนอุปกรณ์ของตนเอง — นี่คือหน้าต่างเดียวกับที่พวกเขาเห็น
        </p>
      )}

      {revealed && <CorrectnessTally tally={tally} />}
    </div>
  );
}
